import { InvitadoTipo } from "../../../types/Invitado";

export const requiredIfFamiliar = {
  validator: (value, formValue) =>
    InvitadoTipo[formValue.tipo] === InvitadoTipo.FAMILIAR && !value,
  message: () => "Campo obligatorio"
};

export const requiredIfAutorizacionDirecta = {
  validator: (value, formValue) =>
    InvitadoTipo[formValue.tipo] === InvitadoTipo.AUTORIZACION_DIRECTA &&
    InvitadoTipo[formValue.tipo] === InvitadoTipo.COMERCIAL &&
    !value,
  message: () => "Campo obligatorio"
};

export const requiredIfCorpAndDirectAuth = {
  validator: (value, formValue) =>
    !value &&
    (InvitadoTipo[formValue.tipo] === InvitadoTipo.AUTORIZACION_DIRECTA ||
      InvitadoTipo[formValue.tipo] === InvitadoTipo.COMERCIAL ||
      InvitadoTipo[formValue.tipo] === InvitadoTipo.CORPORATIVO),
  message: () => "Campo obligatorio"
};

export const requiredClubsIfNotIntercambioComercial = {
  validator: (value, formValue) =>
    InvitadoTipo[formValue.tipo] !== InvitadoTipo.ACCIONISTA &&
    InvitadoTipo[formValue.tipo] !== InvitadoTipo.INTERCAMBIO_COMERCIAL &&
    InvitadoTipo[formValue.tipo] !== InvitadoTipo.CORPORATIVO &&
    (!value || value.length === 0),
  message: () => "Debe seleccionar al menos un club"
};

export const requiredIfIntercambioComercial = {
  validator: (value, formValue) =>
    (InvitadoTipo[formValue.tipo] === InvitadoTipo.ACCIONISTA ||
      InvitadoTipo[formValue.tipo] === InvitadoTipo.INTERCAMBIO_COMERCIAL ||
      InvitadoTipo[formValue.tipo] === InvitadoTipo.CORPORATIVO) &&
    !value,
  message: () => "Campo obligatorio"
};

export const hiddenIfNotFamiliar = formValue =>
  InvitadoTipo[formValue.tipo] !== InvitadoTipo.FAMILIAR;

export const hiddenIfNotAutorizacionDirecta = formValue =>
  InvitadoTipo[formValue.tipo] !== InvitadoTipo.AUTORIZACION_DIRECTA &&
  InvitadoTipo[formValue.tipo] !== InvitadoTipo.COMERCIAL;

export const hiddenIfNotCorpAndDirectAuth = formValue =>
  !(
    InvitadoTipo[formValue.tipo] === InvitadoTipo.AUTORIZACION_DIRECTA ||
    InvitadoTipo[formValue.tipo] === InvitadoTipo.COMERCIAL ||
    InvitadoTipo[formValue.tipo] === InvitadoTipo.CORPORATIVO
  );

export const hiddenIfIntercambioComercial = formValue => {
  const tipo = formValue.tipo && InvitadoTipo[formValue.tipo];
  return (
    !tipo ||
    tipo === InvitadoTipo.INTERCAMBIO_COMERCIAL ||
    tipo === InvitadoTipo.ACCIONISTA ||
    tipo === InvitadoTipo.CORPORATIVO
  );
};

export const hiddenIfNotIntercambioComercial = formValue =>
  InvitadoTipo[formValue.tipo] !== InvitadoTipo.ACCIONISTA &&
  InvitadoTipo[formValue.tipo] !== InvitadoTipo.INTERCAMBIO_COMERCIAL &&
  InvitadoTipo[formValue.tipo] !== InvitadoTipo.CORPORATIVO;
